import { render, staticRenderFns } from "./domainResults.vue?vue&type=template&id=14c6723f&"
import script from "./domainResults.vue?vue&type=script&lang=js&"
export * from "./domainResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports